import iconMixin from '../../mixins/iconMixin'

export default {
  mixins: [iconMixin],
  data: function () {
    return {
      viewBox: "0 0 24 24",
      rawSvgPath: '<path d="M18.5,2.825c-1.74,0-3.41,0.811-4.5,2.09c-1.09-1.279-2.759-2.09-4.499-2.09c-3.08,0-5.5,2.42-5.5,5.5 c0,0.14,0.011,0.278,0.022,0.417H0.672C0.301,8.742,0,9.042,0,9.414v5.172c0,0.372,0.301,0.673,0.672,0.673h4.507v3.217 c0,0.272,0.164,0.519,0.415,0.622c0.083,0.034,0.171,0.051,0.257,0.051c0.175,0,0.347-0.069,0.476-0.197l2.525-2.525 c1.091,1.062,2.327,2.188,3.698,3.431L14,21.175l1.451-1.309C20.6,15.185,24,12.105,24,8.325C24,5.245,21.58,2.825,18.5,2.825z  M5.852,13.914H1.345v-3.828h4.507c0.372,0,0.672-0.302,0.672-0.672V7.147L11.376,12l-4.853,4.853v-2.267 C6.524,14.215,6.223,13.914,5.852,13.914z M17.328,15.286v-4.273h-2.377l3.412-6.648v4.272h2.287L17.328,15.286z"/>',
    }
  },
}